/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import Modal, { ModalHeader } from "../Modal";

// Redux Store
import { shallowEqual, useSelector } from "react-redux";
import store from "../../store";
import { SET_CARD_LIST } from "../../store/card/actionTypes";
import { isEmpty } from "lodash";
import { getCardRecordsCardsPurchaseList, getCardsEmployeeList } from "../../apis/finances/cards";
import systemAlert from "../../utils/systemAlert";
import Filters from "../Filters";
import { ControlTable } from "../Table";
import useForm from "../../hooks/useForm";
import { dateToFormat, getDay } from "../../utils/date";
import { getParams } from "../../utils/params";
import Button from "../Button";
import { translation } from "../../utils/translator";
import { CARD_DATA, CARD_TYPE } from "../../constants/CARD_DATA";
import { classnames } from "../../utils/text";
import defaultCardImage from "../../assets/images/bank-card-images/default-card-img.png";
import { cardName } from "../../utils/account-name";
import Badge from "../Badge";
import { getFinanacesScrapingHistoryList, getFinancesAccounts, scrapingFinanaces } from "../../apis/finances/auth";
import { get } from "lodash";
import { useHistory } from "react-router-dom";

const EmployeeCardPurchaseList = () => {
  const { isOpen, employee, permissions } = useSelector(
    (store) => ({
      isOpen: store.CardPurchase.isOpen,
      employee: store.Profile.employee,
      permissions: store.Profile.permissions
    }),
    shallowEqual
  );
  const [usingCards, setUsingCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState({});
  const [isOpenToggle, setIsOpenToggle] = useState(false);

  const [reload, setReload] = useState(false);
  const [isScraping, setIsScraping] = useState(false);
  const [timerValue, setTimerValue] = useState(0);

  const timerId = useRef(null);
  const history = useHistory();
  // 스크래핑
  const [scrapingPermission, setScrapingPermission] = useState(null);
  const [financeScraping, setFinanceScraping] = useState([]);

  const [fields] = useState([
    { title: '거래일자', key: 'useTime', type: 'date' },
    { title: '승인금액', key: 'useAmt', type: 'comma' },
    { title: '거래타입', key: 'useDiv' },
    { title: "상태", key: "apprSt" },
    { title: '가맹점', key: 'useStore' },
    { title: '업종', key: 'storeType' },
    { title: '사업자번호', key: 'storeBizNo' },
    //{ title: '가맹점전화번호', key: 'storeTel' },
  ]);
  const [filters] = useState([
    {
      title: '조회기간',
      type: 'customdatepicker',
      key: 'range.useTime'
    }
  ]);

  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);
    return () => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (isOpen && !isEmpty(employee)) {
      _getEmployeeCards(employee.idx);
    }

    !isEmpty(permissions) && setScrapingPermission(permissions.find(f => f.code === "FINANCE_SCRAPING"));
  }, [isOpen, employee]);

  useEffect(() => {
    if (
      timerValue === 1 &&
      !isEmpty(scrapingPermission) &&
      scrapingPermission.level > 1
    ) {
      setTimerValue(0);
      if (reload && !isEmpty(financeScraping)) {
        getHistories(financeScraping);
      }
    }
  }, [timerValue]);

  const getScrapings = async () => {
    getFinancesAccounts(selectedCard.orgCd).then((res) => {
      const scrapings = [];
      get(res, 'data.accounts', []).forEach((item) => {
        (item?.financeScrapings || []).forEach((data) => {
          if (data.isUsing === 1) {
            scrapings.push({
              ...data,
              orgCd: selectedCard.orgCd,
            });
          }
        });
      });

      setFinanceScraping(
        scrapings.find((f) => f.cardIdx === selectedCard.idx),
      );
    });
  };



  const getHistories = async () => {
    getFinanacesScrapingHistoryList(financeScraping.idx, {
      search: { state: 9 },
    }).then((res) => {
      if (!isEmpty(res.data.histories)) {
        setReload(true);
        setIsScraping(true);
        // isFirst && setIsFirst(false);
      } else {
        setIsScraping(false);
        setReload(false);
        !isEmpty(selectedCard) && submit(form);
      }
    });
  };


  const _getEmployeeCards = async (idx) => {
    try {
      const res = await getCardsEmployeeList(idx);
      const cardList = res.data.cardList.map((card) => ({
        ...card,
        cardCompany: translation(CARD_DATA, card.cardCd, 'code', 'name'),
      }));
      if (isEmpty(cardList)) {
        cancel();
        systemAlert('매칭된 카드가 없습니다.');
      } else {
        setUsingCards(cardList);
        setSelectedCard(cardList[0]);
      }
    } catch (e) {
      cancel();
    }
  };

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    filterSubmit,
    handleSubmit,
    list, setList,
    isLoading, setIsLoading,
    page, setPage,
    limit, setLimit,
    total, setTotal,
    selectedData,
    setSelectedData,
  } = useForm(
    {
      range: {
        useTime: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    if (!isEmpty(selectedCard)) {
      submit(form);
      setSubmit(submit);
      getScrapings();
    }
  }, [selectedCard]);

  const submit = (params) => {
    setIsLoading(true);
    const _params = {
      ...params,
    };
    getCardRecordsCardsPurchaseList(selectedCard.idx, getParams(_params))
      .then((res) => {
        setList(res.data.cardPurchaseList.map((d) => ({
          ...d,
          orgCd: usingCards.find((useCard) => useCard.idx === d.cardIdx).orgCd
        })));
        setTotal(res.data.totalCount);
      })
      .catch(() => { })
      .finally(() => setIsLoading(false));
  };

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setSelectedData(null);
    store.dispatch({
      type: SET_CARD_LIST,
      payload: {
        isOpen: false
      }
    });
  };

  const handleOnSupply = () => {
    store.dispatch({
      type: SET_CARD_LIST,
      payload: {
        isOpen: false,
        selectedData
      }
    });
  };

  const handleOnChangeCard = (value) => {
    setIsOpenToggle(false);
    setSelectedCard(usingCards[value]);
    setForm({
      ...form,
      page: 0,
      limit: 10
    });
  };
  const runScrapping = () => {
    systemAlert('수동 스크래핑을 진행하시겠습니까?', {
      buttons: [
        {
          label: "취소",
          color: "text"
        },
        {
          label: '확인',
          onClick: () => {
            const params = {
              svcCd: 'C0005',
              sdate: dateToFormat(new Date(), 'YYYYMMDD'),
              edate: dateToFormat(new Date(), 'YYYYMMDD'),
            };

            setIsLoading(true);
            scrapingFinanaces(financeScraping.idx, params)
              .then(() => {
                setReload(true);
                setIsScraping(true);
                getHistories(financeScraping);
                systemAlert(<>
                  <p>스크래핑 요청에 성공하였습니다.</p>
                  <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                  <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                  <p> 관리자 -&gt; 금융정보 자동 수집 -&gt; 수집이력에서</p>
                  <p>스크래핑 결과를 확인하실 수 있습니다.</p>
                </>
                  , {
                    buttons: [
                      {
                        label: "수집이력 확인하기",
                        onClick: () => {
                          history.push("/manager/financial?tab=scraping-history");
                        }
                      },
                      {
                        label: "확인",
                        onClick: () => {
                          getHistories();
                        }
                      },
                    ]
                  });
              })
              .finally(() => {
                setIsLoading(false);
              });
          },
        },
      ]
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      close={cancel}
    >
      <div className="task-employee-card-purchase-list">
        <ModalHeader>"{employee.name}"님이 보유한 카드 매입 내역 리스트</ModalHeader>
        <div className="using-card-container">
          <div className="using-card-select" onClick={() => setIsOpenToggle(!isOpenToggle)}>
            <>
              <div className="card-img-wrap">
                <img src={selectedCard.cardImg || defaultCardImage} alt={selectedCard.cardName} onError={(e) => e.target.src = defaultCardImage} />
              </div>
              <Badge
                className="ml-16"
                color={selectedCard.orgCd === 'card' ? "secondary" : 'warning'}
                size="sm"
                label={translation(CARD_TYPE, selectedCard.orgCd)}
              />
              <span
                className="card-name"
              >
                {cardName(selectedCard.cardCompany || selectedCard.cardName, selectedCard.cardNo)}
              </span>
              <span
                className="ml-16"
              >
                {selectedCard.cardName}
              </span>
            </>
          </div>
          <ul className={classnames("using-card-option-view", { open: isOpenToggle })}>
            {usingCards.map((card, idx) => {
              const { cardImg, cardCompany, cardNo, orgCd } = card;
              return (
                <li className="using-card-option-item" key={idx} onClick={() => handleOnChangeCard(idx)}>
                  <>
                    <div className="card-img-wrap">
                      <img src={cardImg || defaultCardImage} alt={card.cardName} onError={(e) => e.target.src = defaultCardImage} />
                    </div>
                    <Badge
                      className="ml-16"
                      color={orgCd === 'card' ? "secondary" : 'warning'}
                      size="sm"
                      label={translation(CARD_TYPE, orgCd)}
                    />
                    <span
                      className="card-name"
                    >
                      {cardName(cardCompany || card.cardName, cardNo)}
                    </span>
                    <span className="ml-16">
                      {card.cardName}
                    </span>
                  </>
                </li>
              );
            })}
          </ul>
        </div>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        {/* button */}
        {!isEmpty(scrapingPermission) &&
          scrapingPermission.level >= 1 && (
            <Button
              className="full-width mb-10"
              size="lg"
              onClick={() => { runScrapping(); }}
              label="거래내역 스크래핑"
              disabled={isScraping ||
                isEmpty(selectedCard) ||
                isEmpty(financeScraping)}
            />
          )}
        <ControlTable
          isSelect
          setSelectedData={setSelectedData}
          fields={fields}
          list={list}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleOnSupply}
            disabled={isEmpty(selectedData)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeCardPurchaseList;
